/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import WyExperienceAndAutomationPage from '../components/home/wy-experience-and-automation-page.vue'

export default [
  {
    path: '/experienceAndAutomation',
    name: 'home',
    component: WyExperienceAndAutomationPage,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['custTypes', 'languages', 'devices'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  }
]